export default __webpack_public_path__ + "static/New and innovative way to train contractor workers on fatal HSE risks-8164bc03680669a744fc6d99905fa40e.jpg";